import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '@ktag/styleguide/dist/react';

interface ToleranceDropdownProps {
  value: number;
  onChange: (e: any) => void;
}

const optionKeys = [1, 2, 5, 10, 20, 50, 100, 200];

const ToleranceDropdown = ({ value, onChange }: ToleranceDropdownProps) => {
  const { t } = useTranslation('agisviewer');

  const options = optionKeys.map((tolerance) => ({
    label: `${tolerance} m`,
    value: tolerance,
  }));

  return (
    <SelectInput
      value={value}
      isSearchable={false}
      label={t('tolerance')}
      name="tolerancefield"
      onChange={onChange}
      options={options}
    />
  );
};

export default ToleranceDropdown;
